import React from 'react'

const ManageTheme = () => {
  return (
    <div>
      theme
    </div>
  )
}

export default ManageTheme
